package com.milta.core.localization.translations.de

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Foto",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "gerade gesendet",
    fileWaitingConnectionLabel = "wartet auf Verbindung",
    analysingTitle = "Dokument wird gelesen…",
    analysingSubtitle = "Das Extrahieren der Zustellungen kann einige Sekunden dauern.",
    analysingSubtitlePdf = "Claude Haiku extrahiert die Zustellungen — bei einem gescannten PDF kann dies einige Sekunden dauern.",
    stepFileSent = "Datei gesendet",
    stepExtracting = "Felder werden extrahiert",
    stepReview = "Überprüfung vor dem Hinzufügen",
    successTitle = "Zustellung erkannt",
    successSubtitle = "Überprüfen Sie die Angaben, bevor Sie sie zur Tour hinzufügen.",
    addToRouteButton = "Zur Tour hinzufügen",
    scanAnotherButton = "Weiteres Dokument scannen",
    partialTitle = "Fast vollständig",
    partialSubtitle = "Ein Feld konnte auf dem Dokument nicht gelesen werden.",
    missingFieldPlaceholder = "Noch auszufüllen…",
    partialBannerText = "Einige Angaben konnten nicht gelesen werden. Sie können so bestätigen und später vervollständigen, oder ein klareres Dokument senden.",
    retryFileButton = "Andere Datei senden",
    validateAndContinueButton = "Bestätigen und fortfahren",
    attemptLabel = "Versuch",
    errorTitleUnreadable = "Dokument nicht lesbar",
    errorTitleMissingFields = "Angaben nicht gefunden",
    errorTitleNetworkError = "Problem bei der Analyse",
    errorTitleGeneric = "Analyse fehlgeschlagen",
    errorSubtitle = "Wir konnten auf dieser Datei keine Zustellung erkennen.",
    errorBannerSuffixUnreadable = "Bild zu dunkel oder Text abgeschnitten. Machen Sie ein gut ausgerichtetes, gut beleuchtetes Foto oder senden Sie eine klarere Datei.",
    errorBannerSuffixMissingFields = "es wurden keine verwertbaren Angaben gefunden. Überprüfen Sie den Inhalt der Datei oder senden Sie eine andere.",
    errorBannerSuffixNetworkError = "der Analysedienst hatte ein Netzwerkproblem. Versuchen Sie es in ein paar Momenten erneut.",
    errorBannerSuffixGeneric = "während der Analyse ist ein unerwarteter Fehler aufgetreten. Versuchen Sie es erneut oder senden Sie eine andere Datei.",
    retryWithNewFileButton = "Mit anderer Datei erneut versuchen",
    manualEntryButton = "Manuell eingeben",
    attemptsRemainingNote = "Ihnen bleibt noch 1 Versuch für dieses Dokument.",
    maxAttemptsTitle = "Weiterhin nicht lesbar",
    maxAttemptsSubtitle = "Dieses Dokument konnte nach 2 Versuchen nicht gelesen werden.",
    maxAttemptsBanner = "Versuchslimit für dieses Dokument erreicht. Vervollständigen Sie die Zustellung manuell, oder starten Sie den Import mit einem neuen Dokument neu.",
    retryUnavailableButton = "Erneut versuchen — nicht verfügbar",
    newDocumentButton = "Neues Dokument importieren",
    serviceUnavailableTitle = "Dienst vorübergehend nicht verfügbar",
    serviceUnavailableSubtitle = "Die automatische Analyse reagiert derzeit nicht.",
    serviceUnavailableBanner = "Versuchen Sie es in ein paar Momenten erneut, oder vervollständigen Sie die Zustellung in der Zwischenzeit manuell.",
    offlineTitle = "Sie sind offline",
    offlineSubtitle = "Ihre Datei ist bereit, wurde aber noch nicht gesendet.",
    offlineBanner = "Stellen Sie die Internetverbindung wieder her und starten Sie die Analyse erneut. Es wurde nichts an den Server gesendet — es wurde kein Versuch gezählt.",
    retryOfflineButton = "Erneut versuchen — keine Verbindung",
    unsupportedFormatBanner = "Nicht unterstütztes Dateiformat. Wählen Sie ein Foto, ein PDF oder eine Excel-/CSV-Datei.",
    validationTitle = "Zustellungen überprüfen",
    fileRejectedTitle = "Datei nicht gesendet",
    fileRejectedSubtitle = "Wählen Sie eine andere Datei, um fortzufahren.",
    bannerFileRequired = "es wurde keine Datei ausgewählt. Wählen Sie eine PDF-Datei, um fortzufahren.",
    bannerInvalidPdfFormat = "nicht unterstütztes Format. Hier werden nur PDF-Dateien akzeptiert.",
    bannerFileTooLarge = "Datei zu groß. Wählen Sie eine kleinere PDF-Datei.",
    chooseAnotherFileButton = "Andere Datei wählen",
)
